export const defaultConfigValidation = {
    required: null,
    requiredError: null,
    regex: null,
    regexError: null,
    minLength: null,
    minLengthError: null,
    range: null,
    rangeError: null,
};
export const defaultNumberValidation = {
    ...defaultConfigValidation,
    regex: '^(0|[1-9]\\d*)(\\.\\d)?$',
    regexError: 'Value should be a number',
};
export const defaultTextValidation = {
    ...defaultConfigValidation,
    regex: '^[A-Za-z]+$',
    regexError: 'Value should be a text',
};
export const defaultAlphaNumericValidation = {
    ...defaultConfigValidation,
    regex: '^(?:\\d+|\\d+\\.\\d+)[A-Za-z]*$',
    regexError: 'Value should be a alphanumeric',
};
//# sourceMappingURL=config-types.js.map